
export class SceneTimer {

    constructor(mscene) {
        this.playing = false;
        this.paused =  false;
        this.stopped = true;
        this.scene = mscene;
        this.lineIndex = 0;
        this.lines = [];
        this.startTime = 0;
        this.lastTime = 0;
        this.currentTime = 0;
        // The radial timer control is always created and used, but setting this to
        // false will prevent the circular stroke from being visible.
        this.useRadialTimer = false;
        this.currentT = 0;

        this.getLinesFromScene(mscene);
        this.createUI("Time a scene");
    }

    getLinesFromScene(mscene) {
        var timer = this;

        // Each line will produce up to 2 timeouts
        // First, a timeout for the line's offset (250ms default). If this is 0,
        // then no timeout.
        // Next, a timeout for the line's duration.
        // We want to be able to call each timeout sequentially, so we'll store them
        // in an array for easy index-based access
        this.lines = [];

        var linesHTML = mscene.exportHTML(false, false, true, false, mscene.show_next);

        for(var i = 0; i < mscene.lines.length; i++) {
            this.lines.push({
                line:  mscene.lines[i],
                html:  linesHTML[i],
                timeoutFunc: null,
                offsetTimeout: null,
                lineTimeout: null
            });
        }
    }

    setCurrentLine (entry) {
        this.currentLine = entry;
        if (entry) {
            this.setLine(this.currentLine.html);
        }
        else {
            this.setLine();
        }
    }

    setLine (line = null) {
        this.lineDiv.innerHTML = line ? line : "";
    }

    updateLine (t = 0.0) {
        if (this.currentLine && this.currentLine.filteredText != "") {

            var colorStopIndex = this.currentLine.filteredStartIndex
                + Math.round((this.currentLine.filteredStopIndex - this.currentLine.filteredStartIndex) * t);

            colorStopIndex = iclamp(colorStopIndex, this.currentLine.filteredStartIndex, this.currentLine.filteredStopIndex);

            var trueStartIndex = this.currentLine.filteredLocationMap[this.currentLine.filteredStartIndex];
            var trueStopIndex = this.currentLine.filteredLocationMap[colorStopIndex];

            var karaokeColor = "FFFFFF";

            var colorizedCurrentLine = String.format("{0}<strong style=\"color: #{1};\">{2}</strong>{3}",
                this.currentLine.html.substring(0, trueStartIndex),
                karaokeColor,
                this.currentLine.html.substring(trueStartIndex, trueStopIndex),
                this.currentLine.html.substring(trueStopIndex)
            );

            this.setLine(colorizedCurrentLine);
        }
    }

    createUI (dialogTitle = "") {
        var timer = this;

        // timer container
        this.div = $("<div/>").attr("id", "timer_div").appendTo("body");

        this.div.dialog({
            autoOpen: false,
            show: {
                effect: "puff",
                duration: 100
            },
            hide: {
                effect: "explode",
                duration: 100
            },
            width: "80vw",
            height: 600,
            title: dialogTitle,
            close: function() {
                timer.stop();

                $(this).dialog('destroy').remove();
            }
        });

        // Resizes the dialog
        $(window).resize(function () {
            $("#timer_div").dialog("option", "position", {my: "center", at: "center", of: window});
        });

        // Controls div contains timer and buttons
        var controlsDiv = document.createElement("div");
        controlsDiv.id = "timer_controls_div";
        this.div.append(controlsDiv);

        this.timerDiv = document.createElement("div");
        this.timerDiv.id = "timer_timer_div";
        this.timerDiv.innerHTML = "0";
        controlsDiv.appendChild(this.timerDiv);
        controlsDiv.appendChild(document.createElement("br"));

        //td.appendChild(this.timerDiv);
        //td.id = "timer_td";

        //td.appendChild(document.createElement("br"));

        // Add player buttons
        var buttonDiv = document.createElement("div");
        buttonDiv.id = "timer_button_div";
        controlsDiv.appendChild(buttonDiv);
        var playPauseButton = document.createElement("button");
        buttonDiv.appendChild(playPauseButton);
        playPauseButton.innerHTML = "play";
        playPauseButton.onclick = function() {
            if (timer.playing) {
                timer.pause();
                playPauseButton.innerHTML = "resume";
            }
            else {
                timer.play();
                playPauseButton.innerHTML = "pause";
            }
        };

        var stopButton = document.createElement("button");
        buttonDiv.appendChild(stopButton);
        stopButton.innerHTML = "stop";
        stopButton.onclick = function() {
            timer.stop();
            playPauseButton.innerHTML = "play";
        };

        var nextButton = document.createElement("button");
        buttonDiv.appendChild(nextButton);
        nextButton.innerHTML = "Next";
        nextButton.onclick = function() {
            timer.callNextEntry();
        };


        // Row 1, col 2: Displays line
        // td = document.createElement("td");
        // td.align = "center";
        // td.valign = "top";
        // tr.appendChild(td);
        this.lineDiv = document.createElement("div");
        this.lineDiv.id = "timer_line_div";
        this.div.append(this.lineDiv);


        // // Row 2: player buttons
        // tr = document.createElement("tr");
        // tbody.appendChild(tr);
        // td = document.createElement("td");
        // tr.appendChild(td);


    }

    // Sets flags for playing and calls the next line entry
    play () {
        let timer = this;
        if (this.playing) {
            return;
        }
        // Handle play differently if previously paused
        if (this.paused) {
            this.resume();
        }
        else {
            let countdown = 3000;
            this.timerInterval = setInterval(function () {
                $("#timer_timer_div").text((countdown / 1000.0).toFixed(2));
                countdown -= 50;
                if (countdown <= 0) {
                    clearInterval(timer.timerInterval);
                    timer.playing = true;
                    timer.startTime = Date.now();
                    timer.lastTime = timer.startTime;
                    timer.timerInterval = setInterval(function () {
                        timer.currentTime = Date.now();
                        let diff = (timer.currentTime - timer.startTime) / 1000.0;
                        $("#timer_timer_div").text(diff.toFixed(2));
                    }, 16);
                    timer.paused = false;
                    timer.stopped = false;
                    timer.setCurrentLine(timer.lines[timer.lineIndex]);
                }
            }, 50);
        }
    };

    // Sets flags for pause, record time of pause, clear the next line timeout, and
    // stop the radial timer
    pause () {
        if (this.playing) {
            this.playing = false;
            this.paused = true;
            this.stopped = false;

            this.pauseTime = Date.now();

            if (this.currentTimeout) {
                clearTimeout(this.currentTimeout);
            }

            if (this.timerInterval) {
                clearInterval(this.timerInterval);
            }

            if (this.radialTimer) {
                this.radialTimer.stop();
            }
        }
    };

    // Resume play from pause
    resume () {
        if (this.paused) {
            this.playing = true;
            this.paused = false;
            this.stopped = false;

            // Get time remaining based on
            var timeLeft = this.currentDuration - (this.pauseTime - this.currentStartTime);

            // Check if we should set the timer
            var setTimer = this.currentSetTimer;

            // This will call the paused timeout with the appropriate amount of time
            // remaining. It'll also update the timeout flags so we can support
            // multiple pauses per line
            this.callTimeout(this.currentFunction, timeLeft, false, true);

            this.currentSetTimer = setTimer;

            // If the paused timeout had set the timer, then we should update it
            // to reflect the resume command
            if (setTimer) {
                // Update the timer to use the amount of time left
                //this.setLineTimer(timeLeft, false);
                this.radialTimer.set(this.currentT);
                //this.animateTimer(1.0);
            }
        }
    }

    // Stops the player all together
    stop () {
        this.playing = false;
        this.paused = false;
        this.stopped = true;
        // Resets the current entry counter back to 0
        this.lineIndex = 0;
        clearInterval(this.timerInterval);
        $("#timer_timer_div").html("0");

        // Clear current line
        this.setCurrentLine();

    };

    // Calls the current line entry's timeout functions to update the timer and
    // line div, then increments the current line entry counter. When the counter
    // exceeds the number of lines, calls stop.
    callNextEntry() {
        if (this.playing) {
            if (this.lineIndex < this.lines.length) {
                // Set the duration for this line
                let lineDuration = (this.currentTime - this.lastTime) / 1000.0;
                this.lines[this.lineIndex].duration = lineDuration;
                this.scene.lines[this.lineIndex].duration = lineDuration;
                this.scene.refreshTimings();
                this.lastTime = this.currentTime;
                this.lineIndex++;
                this.setCurrentLine(this.lines[this.lineIndex]);
            }
            else {
                this.stop();
            }
        }
    }


    // MTimer.prototype.animateTimer = function(t, startTime = 0) {
    //     var timer = this;

    //     // Actually begins the timer to transition from 1 (full) to 0 (empty)
    //     if (startTime === 0) {
    //         startTime = Date.now();
    //     }

    //     if (this.radialTimer) {
    //         this.radialTimer.startTime = startTime;

    //         this.radialTimer.stop();
    //         this.radialTimer.animate(t, {
    //             step: function(state, circle, attachment) {
    //                 var t = timer.radialTimer.value();
    //                 var color = chroma.mix("#00FF0000", "#FF0000", t, "hsl");
    //                 circle.path.setAttribute('stroke', timer.useRadialTimer ? color : null);
    //             }
    //         }, function () {
    //             timer.radialTimer.setText("0.00");
    //         });
    //     }


    //     if (this.timerInterval) {
    //         clearInterval(this.timerInterval);
    //     }

    //     this.timerInterval = setInterval(function() {
    //         if (timer.playing) {
    //             // Update timer display
    //             timer.currentT = timer.radialTimer.value();
    //             timer.updateLine(timer.currentT);
    //             var durationDiff = timer.lineDuration * (1.0 - timer.currentT);
    //             if (durationDiff >= 0) {
    //                 timer.radialTimer.setText((durationDiff / 1000.0).toFixed(1).toString());
    //             }
    //         }
    //     }, 50);
    // }

    // Wrapper function to help this player set timeouts. This way, we can
    // always have a reference to any timeout currently active for play/pause
    // purposes.
    callTimeout (fn, durationMS, setTimer = false, updateFlags = true) {
        var to = setTimeout(fn, durationMS);
        if (updateFlags) {
            this.currentTimeout = to;
            this.currentFunction = fn;
            this.currentDuration = durationMS;
            
            this.currentSetTimer = setTimer;
        }

        if (setTimer) {
            this.setLineTimer(durationMS);
        }
    }
}